export default __webpack_public_path__ + "static/media/168.bf8fd9fe.svg";